export default function RegistresConfiguration($translatePartialLoaderProvider) {
	$translatePartialLoaderProvider.addPart('registres');
	$translatePartialLoaderProvider.addPart('errors.rndts');
}

RegistresConfiguration.$inject = ['$translatePartialLoaderProvider'];
